import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiSession } from '@brighthub/uisession';
import { ClientInfoComponent } from '../client-info/client-info.component';

@Component({
  selector: 'bai-client-search-result',
  imports: [CommonModule, ClientInfoComponent],
  templateUrl: './client-search-result.component.html',
  styleUrl: './client-search-result.component.scss',
})
export class ClientSearchResultComponent {
  @Input() data!: UiSession;
  @Input() providerId!: string;
}
